<app-common-modal-form
  header="Annature Login"
  confirmText="Login"
  closeText="Cancel"
  icon="ic-mail-20"
  [formGroup]="form"
  (close)="close()"
  (confirm)="confirm()"
  [isLoading]="isLoading()"
>
  <div class="pb-3 d-flex flex-column gap-16">
    <app-input label="ID" formControlName="clientId"/>
    <app-input label="Key" formControlName="clientKey"/>
  </div>
</app-common-modal-form>
